import { motion } from 'framer-motion';

import { Stage } from '@/components/Stage/Stage';
import useColor from '@/hooks/domain/useColor';

import {
  HEY_SYNCLY_ANSWER_STATUS,
  HeySynclyAnswerStatusMap,
} from '../../model';

export const StatusDisplay = (props: { status: HEY_SYNCLY_ANSWER_STATUS }) => {
  const { status: currentStatus } = props;
  return (
    <Stage>
      {HeySynclyAnswerStatusMap.keys()
        .toArray()
        .map((status) => {
          return (
            <Stage.Scene key={status} status={currentStatus === status}>
              <StatusDisplayItem status={status} />
            </Stage.Scene>
          );
        })}
    </Stage>
  );
};

export const StatusDisplayItem = (props: {
  status: HEY_SYNCLY_ANSWER_STATUS;
}) => {
  const { status } = props;
  const text = HeySynclyAnswerStatusMap.get(status);
  const color = useColor();

  if (status === HEY_SYNCLY_ANSWER_STATUS.FAIL) {
    return (
      <div className="flex text-red-600 font-medium py-2 px-3">{text}</div>
    );
  }

  const gradientStyle = `linear-gradient(90deg, ${color.gray700} 0%, ${color.gray600} 40%, ${color.gray400} 45%, ${color.gray400} 55%, ${color.gray600} 60%, ${color.gray700} 100%)`;

  return (
    <div className="flex items-center gap-1 font-medium py-2 px-2">
      <motion.span
        style={{
          background: gradientStyle,
          backgroundSize: '200% 100%',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          color: 'transparent',
        }}
        animate={{
          backgroundPosition: ['200% 0%', '-200% 0%'],
        }}
        transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: 'easeOut',
        }}
      >
        {text}
      </motion.span>
    </div>
  );
};
